// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Avatar_avatar__uxy_q","organisationAvatar":"Avatar_organisationAvatar__AjjQ_"};